@import '~style-sheet-helpers/core.less';

.header {
  font-size: 20px;
  font-weight: @bold;
  margin-bottom: 10px;
}
